// Libraries
import { Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Box } from '@chakra-ui/react';
// Components
import { RatingPicker } from '../RatingPicker';
import { OptimizeAccordionProps } from './OptimizeAccordion.types';
// Helpers
// Types
import { RatingKeys } from '@globalTypes/index';

/**
 * An accordion component used for optimization settings.
 *
 * @component
 * @param {OptimizeAccordionProps} props - The props for the OptimizeAccordion component.
 * @param {string} props.title - The title to display on the accordion button.
 * @param {boolean} props.isLoading - Indicates whether the optimization operation is in progress.
 * @param {FormContext} props.formCtx - Context object that provides form-related functionalities and values.
 * @param {(state: SimulateParameters) => void} [props.updateOptimizedSpeeds] - Callback to update the optimized speeds based on form values.
 *
 * @returns {ReactElement} The OptimizeAccordion component.
 */
export const OptimizeAccordion = (props: OptimizeAccordionProps) => {
  const { title, isLoading, formCtx, onClick } = props;
  const index = formCtx.values.canOptimize;

  return (
    <Accordion p={0} w='full' index={index} border='none'>
      <AccordionItem p={0} border='none' isDisabled={false}>
        <AccordionButton p={0} width='fit-content' onClick={onClick}>
          <Box as='span' fontSize='s' color='tealishBlue' textAlign='left'>
            {title}
          </Box>
          <AccordionIcon color='tealishBlue' />
        </AccordionButton>
        <AccordionPanel p={0}>
          <RatingPicker
            name='rating'
            flex={1}
            w='full'
            mt={2}
            isDisabled={isLoading}
            optimizedSpeeds={formCtx.values.optimizedSpeeds}
            value={formCtx.values.ciiRating}
            onChange={(rating: RatingKeys) => {
              formCtx.setValues({
                ...formCtx.values,
                ciiRating: rating,
                ballastAvgSpeed: formCtx.values.optimizedSpeeds[rating].ballastSpeedKts,
                ladenAvgSpeed: formCtx.values.optimizedSpeeds[rating].ladenSpeedKts,
              });
            }}
          />
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
};
